export const KIND_OF_SOUND = {
    BACKGROUND: "BACKGROUND",
    ADD_SCORE: "ADD_SCORE",
    ANSWER_SELECTION: "ANSWER_SELECTION",
    ASK_QUESTION: "ASK_QUESTION",
    CORRECT_ANSWER_1: "CORRECT_ANSWER_1",
    CORRECT_ANSWER_2: "CORRECT_ANSWER_2",
    WRONG_ANSWER: "WRONG_ANSWER"
}
